import Class from "@material-ui/icons/Class"
import Comment from "@material-ui/icons/Comment"
import CameraAlt from "@material-ui/icons/CameraAlt"
import DataUsage from "@material-ui/icons/DataUsage"
import ExitToApp from "@material-ui/icons/ExitToApp"
import Home from "@material-ui/icons/Home"
import Icon from "@material-ui/core/Icon"
import InsertChartOutlined from "@material-ui/icons/InsertChartOutlined"
import KeyboardBackspace from "@material-ui/icons/KeyboardBackspace"
import Menu from "@material-ui/icons/Menu"
import PhotoAlbum from "@material-ui/icons/PhotoAlbum"
import React from "react"
import Search from "@material-ui/icons/Search"
import Settings from "@material-ui/icons/Settings"
import Edit from "@material-ui/icons/Edit"
import Print from "@material-ui/icons/Print"
import Delete from "@material-ui/icons/Delete"
import ListAlt from "@material-ui/icons/ListAlt"
import CloseRounded from "@material-ui/icons/CloseRounded"
import Bookmark from "@material-ui/icons/Bookmark"
import SvgIcon from "@material-ui/icons/Class"
import Add from "@material-ui/icons/Add"
import SyncProblemIcon from "@material-ui/icons/SyncProblem"
import TrashIcon from "../../images/assets/svg/icon-trash.svg"
import WellnessMind from "../../images/assets/svg/wellness-mind.svg"
import WellnessWork from "../../images/assets/svg/wellness-work.svg"
import WellnessBody from "../../images/assets/svg/wellness-body.svg"
import WellnessLove from "../../images/assets/svg/wellness-love.svg"
import WellnessPlay from "../../images/assets/svg/wellness-play.svg"
import WellnessSoul from "../../images/assets/svg/wellness-soul.svg"
import RightArrow from "../../images/assets/svg/right-arrow.svg"
import Formatting from "../../images/assets/svg/Formatting.svg"
import WellnesIcon from "../../images/assets/svg/IC_WellnessTag.svg"

// import { Search } from "@material-ui/icons"

const Icons = ({ icon, fa, svg, ...rest }) => {
  const icons = {
    home: Home,
    class: Class,
    add: Add,
    photo_album: PhotoAlbum,
    analytics: InsertChartOutlined,
    settings: Settings,
    comment: Comment,
    logout: ExitToApp,
    menu: Menu,
    arrow: KeyboardBackspace,
    spinner: DataUsage,
    search: Search,
    camera: CameraAlt,
    edit: Edit,
    trash: Delete,
    print: Print,
    list: ListAlt,
    close: CloseRounded,
    bookmark: Bookmark,
    mind: WellnessMind,
    work: WellnessWork,
    body: WellnessBody,
    love: WellnessLove,
    play: WellnessPlay,
    soul: WellnessSoul,
    right_arrow: RightArrow,
    sync_problem: SyncProblemIcon,
    formatting: Formatting,
    wellnessIcon: WellnesIcon,
  }
  const svgs = {
    trash: TrashIcon,
  }
  const styled = rest.style
    ? Object.assign(rest.style, { fontSize: "inherit", overflow: "visible" })
    : { fontSize: "inherit", overflow: "visible" }
  if (fa) {
    const far = ["calendar", "edit"]

    return (
      <Icon
        className={`${far.includes(fa) ? "far" : "fa"} fa-${fa} ${
          rest.className
        }`}
        style={styled}
      />
    )
  } else if (svg) {
    const Component = svgs[svg]
    return (
      <SvgIcon
        component={Component}
        viewBox="0 0 53 53"
        style={{ height: "100%" }}
      />
    )
  } else {
    const Component = icons[icon]
    return <Component {...rest} style={styled} />
  }
  // console.log("Component", Component)
  // return <HomeIcon color="white" />
  // return <Home color="inherit" />
  // return <Icon>add_circle</Icon>
}

export default Icons
